import * as Contentful from 'contentful'
import * as CFRichTextTypes from '@contentful/rich-text-types'

import { SectionContent, TypeSectionFields } from './section'
import { TypeComponentTextInput } from './component-text-input'
import { TypeSingleColumn } from './single-column'
import { TypeItemLlmPrompt } from './item-llm-prompt'

export enum GoTemplatesLayoutType {
  Multipstep = 'multistep',
  SideBySide = 'sideBySide',
}

export interface TypeSectionGoTemplatesToolFields extends TypeSectionFields {
  title: CFRichTextTypes.Document
  description: CFRichTextTypes.Document
  questions: TypeComponentTextInput[]
  llmPrompt: TypeItemLlmPrompt | CFRichTextTypes.Document
  submitButtonText: CFRichTextTypes.Document
  loadingButtonText?: CFRichTextTypes.Document
  outputLabel: CFRichTextTypes.Document
  outputDescription: CFRichTextTypes.Document
  persistentCtaCard: TypeSingleColumn
  signupWall: TypeSingleColumn
  upgradeWall: TypeSingleColumn
  layout?: GoTemplatesLayoutType
}

export type TypeSectionGoTemplatesTool = Contentful.Entry<TypeSectionGoTemplatesToolFields>

export type MultiStepProps = Pick<TypeSectionGoTemplatesToolFields, 'title' | 'description' | 'questions'> & {
  persistentCtaCardContent?: SectionContent
}

// TODO: Clean up after migration
export const isLlmPromptReferenceToEntry = (
  prompt: TypeItemLlmPrompt | CFRichTextTypes.Document
): prompt is TypeItemLlmPrompt => {
  return !!(prompt as TypeItemLlmPrompt)?.fields?.prompt
}
